    export const USER_PERMISSION_CODES = {
    WEB_USER_COMMON: 'WEB_USER_COMMON',
    WEB_SYNC_USER: 'WEB_SYNC_USER',
} as const;

